<template>
    <div>
        <div class="container">
            <div v-if="mainbody" v-html="mainbody" v-epi-edit="'MainBody'" class="c-start text-center font-medium text-2xl py-12"></div>
        </div>
        <div class="bg-tundora-500 mb-12">
            <div class="md:container">
                <div class="flex flex-wrap lg:flex-nowrap items-stretch justify-center">
                    <div
                            v-for="item in items" :key="item.id"
                            class="lg:flex-1 w-1/2 lg:w-auto max-w-xs"
                    >
                        <a
                            :href="item.isExternal ? item.externalUrl : item.url"
                            class="flex flex-col h-full border-t-10 bg-tundora-500 items-center text-center pt-2 pb-4" :class="[`border-${item.color}-500`, `hover:bg-${item.color}-500`]"
                        >
                            <img :src="item.bildeIkkeValgt" class="pb-3 w-24"/>
                            <span class="flex justify-center items-center text-white text-lg h-full px-4 break-word">{{ item.name }}</span>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['categories','mainbody'],
    data() {
        return {
            items: this.categories.filter(cat => !cat.hideStartpage)
        };
    }
};
</script>
